import { all, takeLatest, call, put, select } from 'redux-saga/effects';
import { fetchCurrentPlan } from './Settings.actions';
import { Action } from '@reduxjs/toolkit';
import { Unwrap } from '../../domains/app';
import SpaceService from '../../service/Space.service';
import { RootState } from '../../app/store';
import { setCurrentPlan } from './Settings.slice';

function* fetchCurrentPlanSaga(action: Action) {
  try {
    const selectedAccount: RootState['app']['selectedAccount'] = yield select(
      (state: RootState) => state.app.selectedAccount,
    );
    const res: Unwrap<ReturnType<
      typeof SpaceService.fetchCurrentSubscription
    >> = yield call(
      SpaceService.fetchCurrentSubscription,
      selectedAccount?.id as string,
    );

    yield put(setCurrentPlan(res));
  } catch (e) {
    yield put(setCurrentPlan(undefined));
    console.error(e);
  }
}

// eslint-disable-next-line
export default function* () {
  yield all([takeLatest(fetchCurrentPlan.toString(), fetchCurrentPlanSaga)]);
}
